import { useEffect, useRef } from "react";
import Hls from "../../utils/hlsSafe";

const CameraHls = ({ url }) => {
  const videoRef = useRef(null);
  useEffect(() => {
    const video = videoRef.current;
    if (!video || !url) return undefined;
    if (video.canPlayType("application/vnd.apple.mpegurl")) {
      video.src = url;
      video.play().catch(() => {});
      return () => { video.removeAttribute("src"); video.load(); };
    }
    if (!Hls.isSupported()) return undefined;
    const hls = new Hls({ lowLatencyMode: false, maxBufferLength: 6 });
    hls.loadSource(url);
    hls.attachMedia(video);
    hls.on(Hls.Events.MANIFEST_PARSED, () => video.play().catch(() => {}));
    hls.on(Hls.Events.ERROR, (_, data) => {
      if (!data.fatal) return;
      if (data.type === Hls.ErrorTypes.NETWORK_ERROR) hls.startLoad();
      else if (data.type === Hls.ErrorTypes.MEDIA_ERROR) hls.recoverMediaError();
      else hls.destroy();
    });
    return () => hls.destroy();
  }, [url]);
  return <video ref={videoRef} muted autoPlay playsInline style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover" }} />;
};

export default CameraHls;
